import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React from "react";
import {
  LEAVE_DAY_TYPES,
  LEAVE_HALF_DAY_TYPES,
} from "../../../../util/constants";
import {
  CalendarDays,
  Check,
  CircleUserRound,
  ClipboardList,
  X,
} from "lucide-react";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";

const ShowLeaveComponent = ({
  leaveData,
  setLeaveData,
  isViewLeaveData,
  setIsViewLeaveData,
  setApproveRejectViewType,
  setLeaveHistoryID,
  setIsApproveReject,
}: any) => {
  const getDates = () => {
    const formatDate = (dateStr: any) => {
      return new Date(dateStr).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    };
    const startDateObj = leaveData.startDate
      ? new Date(leaveData.startDate)
      : null;
    let endDateObj = leaveData.endDate ? new Date(leaveData.endDate) : null;
    if (endDateObj) {
      endDateObj.setDate(endDateObj.getDate() - 1);
    }
    if (startDateObj && endDateObj) {
      // Compare only the date part
      const startDateStr = startDateObj.toISOString().split("T")[0];
      const endDateStr = endDateObj.toISOString().split("T")[0];
      if (startDateStr === endDateStr) {
        return formatDate(startDateObj);
      }
      return `${formatDate(startDateObj)} - ${formatDate(endDateObj)}`;
    }
    if (startDateObj) {
      return formatDate(startDateObj);
    }
    return "Date not available.";
  };

  return (
    <div>
      <Dialog
        header={
          <h2 className="tw-text-xl tw-font-bold tw-mb-4 tw-flex tw-items-center tw-gap-2">
            <CalendarDays className="tw-text-blue-500" size={20} />
            Leave Details
          </h2>
        }
        visible={isViewLeaveData}
        draggable={false}
        style={{ width: "100vw", maxWidth: 700 }}
        onHide={() => {
          setLeaveData({
            user: null,
            leaveType: null,
            startDate: null,
            endDate: null,
            totalLeaveDays: null,
            leaveDayType: LEAVE_DAY_TYPES.FULL_DAY,
            dayPart: LEAVE_HALF_DAY_TYPES.AM,
            lineManagerName: null,
            departments: null,
            description: null,
            managerComments: null,
          });
          setIsViewLeaveData(false);
        }}
        className="tw-rounded-xl tw-bg-red-500"
      >
        <div className="tw-bg-white tw-border-red-500 tw-rounded-lg tw-shadow-md tw-p-6 tw-w-full">
          {/* <h2 className="tw-text-xl tw-font-bold tw-mb-4 tw-flex tw-items-center tw-gap-2">
            <CalendarDays className="tw-text-blue-500" size={20} />
            Leave Details
          </h2> */}

          <div className="tw-space-y-4 ">
            <div className="tw-bo tw-pb-4">
              <h2 className="tw-font-semibold tw-flex tw-items-center tw-gap-2 tw-mb-2 tw-text-black">
                <CircleUserRound size={18} /> User Details
              </h2>
              <Divider
                align="center"
                className="tw-my-2 tw-bg-gray-200 tw-h-[2px]"
              />
              <div className="tw-grid tw-grid-cols-2 tw-gap-3 tw-text-sm">
                <div className="tw-font-semibold tw-text-gray-900">Name:</div>
                <div className="tw-font-medium">{leaveData?.user ?? ""}</div>

                <div className="tw-font-semibold tw-text-gray-900">
                  Date Range:
                </div>
                <div className="tw-font-medium">{getDates()}</div>

                <div className="tw-font-semibold tw-text-gray-900">
                  Line Manager:
                </div>
                <div className="tw-font-medium">
                  {leaveData?.lineManagerName ?? "N/A"}
                </div>
                <div className="tw-font-semibold tw-text-gray-900">
                  Total Days:
                </div>
                <div className="tw-font-medium">
                  {`${leaveData?.totalLeaveDays ?? ""} ${
                    leaveData?.totalLeaveDays > 1 ? "days" : "day"
                  }`}
                </div>

                <div className="tw-font-semibold tw-text-gray-900">
                  Description:
                </div>
                <div className="tw-font-medium">
                  {leaveData?.description ?? ""}
                </div>
              </div>
            </div>

            <div>
              <h3 className="tw-font-semibold tw-flex tw-items-center tw-gap-2 tw-mb-2 tw-text-black">
                <ClipboardList size={16} /> Leave Information
              </h3>
              <Divider
                align="center"
                className="tw-my-2 tw-bg-gray-200 tw-h-[2px]"
              />

              <div className="tw-grid tw-grid-cols-2 tw-gap-2 tw-text-sm">
                <div className="tw-font-semibold tw-text-gray-900">
                  Leave Type:
                </div>
                <div className="tw-font-medium">
                  {leaveData?.leaveType ?? ""}
                </div>

                <div className="tw-font-semibold tw-text-gray-900">Status:</div>
                <div
                  className={`tw-font-semibold tw-flex tw-items-center tw-gap-1 ${
                    leaveData.status === "SUBMITTED"
                      ? "tw-text-[#007AFF]"
                      : leaveData.status === "APPROVED"
                      ? "tw-text-[#34C759]"
                      : leaveData.status === "REJECTED"
                      ? "tw-text-[#FF3B30]"
                      : leaveData.status === "CANCELLED"
                      ? "tw-text-[#858484]"
                      : "tw-text-[#FF9500]"
                  }`}
                >
                  {leaveData?.status ?? ""}
                </div>

                <div className="tw-font-semibold tw-text-gray-900">
                  Day Type:
                </div>
                <div className="tw-font-medium">
                  {leaveData?.leaveDayType ?? ""}{" "}
                  {leaveData?.leaveDayType && leaveData?.dayPart && "/"}{" "}
                  {leaveData?.dayPart && leaveData.dayPart}
                </div>

                {/* Show manager comments if status is APPROVED or REJECTED */}
                {(leaveData.status === "APPROVED" ||
                  leaveData.status === "REJECTED") && (
                  <>
                    <div className="tw-font-semibold tw-text-gray-900">
                      Manager Comments:
                    </div>
                    <div className="tw-font-medium">
                      {leaveData?.managerComments || "N/A"}
                    </div>
                  </>
                )}
                {/* Show dayPart if leaveDayType is HALF_DAY and dayPart exists */}
                {/* {leaveData?.leaveDayType === LEAVE_DAY_TYPES.HALF_DAY &&
                  leaveData?.dayPart && (
                    <>
                      <div className="tw-font-semibold tw-text-gray-900">
                        Half Day Part:
                      </div>
                      <div className="tw-font-medium">
                        {leaveData.dayPart}
                      </div>
                    </>
                  )} */}
              </div>
              {/* Approve/Reject buttons: only if status is SUBMITTED and current user is line manager */}
              {leaveData.status === "SUBMITTED" &&
                leaveData?.lineManagerID?.toString() ===
                  localStorage.userID?.toString() && (
                  <div className="tw-flex tw-justify-end tw-gap-2 tw-mt-6">
                    <Button
                      type="button"
                      className="tw-bg-green-500 tw-text-white tw-px-4 tw-py-2 tw-rounded tw-font-semibold tw-text-sm tw-shadow hover:tw-bg-green-600 tw-transition"
                      onClick={() => {
                        setLeaveHistoryID(leaveData?.leaveHistoryID);
                        setIsApproveReject(true);
                        setApproveRejectViewType("approve");
                      }}
                    >
                      Approve
                    </Button>
                    <Button
                      type="button"
                      className="tw-bg-red-500 tw-text-white tw-px-4 tw-py-2 tw-rounded tw-font-semibold tw-text-sm tw-shadow hover:tw-bg-red-600 tw-transition"
                      onClick={() => {
                        setApproveRejectViewType("reject");
                        setLeaveHistoryID(leaveData?.leaveHistoryID);
                        setIsApproveReject(true);
                      }}
                    >
                      Reject
                    </Button>
                  </div>
                )}
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ShowLeaveComponent;
